'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_navigation_ButtonNav_ButtonNavButton = require('./ButtonNavButton.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("ButtonNav", {
  list: (props) => [
    props.align && styleEncapsulation.withModifier(`${props.align}-aligned`, {
      justifyContent: `${props.align}`
    }),
    Object.assign(Object.assign({}, styleMixins_reset.listReset), { display: "flex", flexFlow: "wrap", gap: "var(--zds-space-12)" }),
    props.wrap === false && {
      "@media screen and (min-width: 1024px)": {
        display: "grid",
        gridTemplateColumns: `repeat(${props.items.length}, minmax(auto, min-content))`,
        justifyContent: "center"
      }
    },
    props.isButtonFullWidth && styleEncapsulation.withModifier("isButtonFullWidth", {
      "@media screen and (min-width: 1024px)": {
        display: "grid",
        gridTemplateColumns: `repeat(${props.items.length}, 1fr)`
      }
    })
  ],
  item: (isButtonFullWidth) => [
    Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { display: "block" }),
    isButtonFullWidth && styleEncapsulation.withModifier("isButtonFullWidth", {
      flex: "0 0 100%",
      "@media screen and (min-width: 768px)": {
        flex: "1"
      }
    })
  ]
});
const ButtonNav = ({ align, "aria-label": ariaLabel, isButtonFullWidth, items, selectedItemKey, onChooseItem = () => {
}, wrap = false }) => {
  const props = {
    align,
    ariaLabel,
    isButtonFullWidth,
    items,
    onChooseItem,
    selectedItemKey,
    wrap
  };
  const buttonItems = items.map((item) => {
    const isSelected = item.key === selectedItemKey;
    return react.jsx(
      "li",
      { css: Styles.item(isButtonFullWidth), key: item.key, "data-zds": true },
      react.jsx(components_navigation_ButtonNav_ButtonNavButton.ButtonNavButton, { "aria-label": isSelected ? `${item.text}, selected` : item.text, color: "button-nav", hasShadow: false, href: item.href, iconBefore: item.iconBefore, isFullWidth: isButtonFullWidth, isSelected, onClick: (event) => onChooseItem(item, event) }, item.text)
    );
  });
  return react.jsx(
    "nav",
    { "aria-label": ariaLabel, "data-zds": true },
    react.jsx("ul", { css: Styles.list(props), "data-zds": true }, buttonItems)
  );
};

exports.ButtonNav = ButtonNav;
//# sourceMappingURL=ButtonNav.cjs.js.map
